import React from "react";
import { Container, FormArea, SubmitButtonArea } from "./Styled";
import { Intent } from "../../../../model/intent/types";
import { FastField, Form, Formik, FormikValues } from "formik";
import WrapEntityAnnotator from "../../../editor/intentManager/IntentAnnotator/TokenAnnotator/WrapEntityAnnotator";
import { Select } from 'formik-antd';
import SaveButton from "../../../system/saveButton/SaveButton";
import { useDispatch } from "react-redux";
import { saveIntentAction } from "../../../../business/actions/intentActions";
import * as Yup from "yup";
import { Alert } from "antd";
import notification from "../../../../helpers/notification";
import { isContains } from "../../../../helpers/intentHelper";

type IntentSelectorProps = {
    intents: Intent[];
    message: string;
};

const validationSchema = Yup.object().shape({
    intentId: Yup.string().required('Champs requis')
});

const IntentSelector: React.FunctionComponent<IntentSelectorProps> = ({ intents, message }) => {
    const dispatch = useDispatch();

    const onSave = (values: FormikValues) => {
        const intent = intents.find(x => x.id === values.intentId);
        if (intent !== undefined) {
            if(!isContains(intent, values.expression)){
                intent.expressions.push(values.expression);
                dispatch(saveIntentAction.request(intent));
            } else {
                notification.error(
                    'Cette expression existe déja pour cette intention',
                );
            }
        }
    }
    return (
        <Container>
            <Formik
                validationSchema={validationSchema}
                enableReinitialize
                initialValues={{
                    expression: {
                        text: message
                    }
                }}
                onSubmit={(values) => {
                    onSave(values);
                }}
                render={({ values, errors, touched }) => {
                    return <Form>
                        <FormArea>
                            <Select
                                name='intentId'
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Sélectionner une intention"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option ?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {intents.map(({ id, title }) => { return <Select.Option value={id!}>{title}</Select.Option> })}
                            </Select>
                            {
                                //@ts-ignore
                                errors.intentId ? (
                                    //@ts-ignore
                                    <Alert message={errors.intentId} type="error" showIcon />
                                ) : null}
                            <FastField name={'expression'} value={values.expression} component={WrapEntityAnnotator} />
                            <SubmitButtonArea>
                                <SaveButton />
                            </SubmitButtonArea>
                        </FormArea>
                    </Form>
                }}
            />
        </Container>
    );
};

export default IntentSelector;
